"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpPlatformClient = void 0;
const errors_1 = require("./errors");
function createHttpPlatformClient({ baseUrl, systemId, storageKey = "@okton:platform:favorites", }) {
    const api = baseUrl.replace(/\/$/, "");
    function token() {
        if (!systemId)
            return undefined;
        return (sessionStorage.getItem(`@okton:auth:${systemId}:access_token`) ||
            undefined);
    }
    function headers(json = false) {
        const result = {};
        const accessToken = token();
        if (accessToken)
            result.Authorization = `Bearer ${accessToken}`;
        if (json)
            result["Content-Type"] = "application/json";
        return result;
    }
    function readLocalFavorites() {
        try {
            return JSON.parse(localStorage.getItem(storageKey) || "[]");
        }
        catch (_a) {
            return [];
        }
    }
    function writeLocalFavorites(items) {
        localStorage.setItem(storageKey, JSON.stringify(items));
    }
    async function parse(response, fallbackMessage) {
        return (0, errors_1.parseOktonResponse)(response, fallbackMessage);
    }
    return {
        async getApplications() {
            const response = await fetch(`${api}/v1/applications`, {
                credentials: "include",
                headers: headers(),
            });
            return parse(response, "Não foi possível carregar os sistemas da plataforma.");
        },
        async getFavorites() {
            if (!token())
                return readLocalFavorites();
            const response = await fetch(`${api}/v1/me/favorites`, {
                credentials: "include",
                headers: headers(),
            });
            return parse(response, "Não foi possível carregar os favoritos.");
        },
        async addFavorite(targetSystemId) {
            if (!token()) {
                const current = readLocalFavorites();
                if (!current.some((item) => item.systemId === targetSystemId)) {
                    writeLocalFavorites([
                        ...current,
                        { systemId: targetSystemId, order: current.length + 1 },
                    ]);
                }
                return;
            }
            const response = await fetch(`${api}/v1/me/favorites/${encodeURIComponent(targetSystemId)}`, {
                method: "POST",
                credentials: "include",
                headers: headers(),
            });
            await (0, errors_1.parseOktonResponse)(response, "Não foi possível adicionar o favorito.");
        },
        async removeFavorite(targetSystemId) {
            if (!token()) {
                writeLocalFavorites(readLocalFavorites().filter((item) => item.systemId !== targetSystemId));
                return;
            }
            const response = await fetch(`${api}/v1/me/favorites/${encodeURIComponent(targetSystemId)}`, {
                method: "DELETE",
                credentials: "include",
                headers: headers(),
            });
            await (0, errors_1.parseOktonResponse)(response, "Não foi possível remover o favorito.");
        },
        async search(query) {
            const response = await fetch(`${api}/v1/search?q=${encodeURIComponent(query)}`, { credentials: "include", headers: headers() });
            return parse(response, "Não foi possível pesquisar na plataforma.");
        },
        async checkSystemAccess(targetSystemId) {
            const response = await fetch(`${api}/v1/me/bootstrap?system=${encodeURIComponent(targetSystemId)}`, { credentials: "include", headers: headers() });
            return response.ok;
        },
        async getNavigation(targetSystemId) {
            const response = await fetch(`${api}/v1/navigation/${encodeURIComponent(targetSystemId)}`, { credentials: "include", headers: headers() });
            return parse(response, "Não foi possível carregar o menu da plataforma.");
        },
        async getPreferences() {
            const response = await fetch(`${api}/v1/me/preferences`, {
                credentials: "include",
                headers: headers(),
            });
            return parse(response, "Não foi possível carregar suas preferências.");
        },
        async savePreferences(preferences) {
            const response = await fetch(`${api}/v1/me/preferences`, {
                method: "PUT",
                credentials: "include",
                headers: headers(true),
                body: JSON.stringify(preferences),
            });
            return parse(response, "Não foi possível salvar suas preferências.");
        },
        async getBusinessContext(targetSystemId) {
            const response = await fetch(`${api}/v1/me/context/${encodeURIComponent(targetSystemId)}`, { credentials: "include", headers: headers() });
            return parse(response, "Não foi possível carregar o contexto da empresa.");
        },
        async saveBusinessContext(targetSystemId, context) {
            const response = await fetch(`${api}/v1/me/context/${encodeURIComponent(targetSystemId)}`, {
                method: "PUT",
                credentials: "include",
                headers: headers(true),
                body: JSON.stringify(context),
            });
            return parse(response, "Não foi possível salvar o contexto da empresa.");
        },
        async getInvoices() {
            if (!systemId)
                throw new Error("systemId é obrigatório para consultar faturas.");
            const response = await fetch(`${api}/v1/me/billing/invoices?system=${encodeURIComponent(systemId)}`, { credentials: "include", headers: headers() });
            return parse(response, "Não foi possível carregar as faturas.");
        },
        async getBranches() {
            if (!systemId)
                throw new Error("systemId é obrigatório para consultar filiais.");
            const response = await fetch(`${api}/v1/me/branches?system=${encodeURIComponent(systemId)}`, { credentials: "include", headers: headers() });
            return parse(response, "Não foi possível carregar as filiais.");
        },
        async switchBranch(branchId) {
            if (!systemId)
                throw new Error("systemId é obrigatório para trocar filial.");
            const response = await fetch(`${api}/v1/me/branches/${encodeURIComponent(branchId)}/select?system=${encodeURIComponent(systemId)}`, {
                method: "POST",
                credentials: "include",
                headers: headers(),
            });
            return parse(response, "Não foi possível trocar a filial.");
        },
        async generateInvoiceBoleto(invoiceId, newDueDate) {
            if (!systemId)
                throw new Error("systemId é obrigatório para gerar boleto.");
            const response = await fetch(`${api}/v1/me/billing/invoices/${encodeURIComponent(invoiceId)}/boleto?system=${encodeURIComponent(systemId || "")}`, {
                method: "POST",
                credentials: "include",
                headers: headers(true),
                body: JSON.stringify({ newDueDate }),
            });
            return parse(response, "Não foi possível gerar o boleto.");
        },
        async generateInvoicePix(invoiceId) {
            if (!systemId)
                throw new Error("systemId é obrigatório para gerar Pix.");
            const response = await fetch(`${api}/v1/me/billing/invoices/${encodeURIComponent(invoiceId)}/pix?system=${encodeURIComponent(systemId || "")}`, {
                method: "POST",
                credentials: "include",
                headers: headers(true),
                body: JSON.stringify({}),
            });
            return parse(response, "Não foi possível gerar o Pix.");
        },
    };
}
exports.createHttpPlatformClient = createHttpPlatformClient;
//# sourceMappingURL=createHttpPlatformClient.js.map